import { useCallback } from 'react';
import { NumberFormat } from '@instinet-analytics/core-lib';
import { useScale } from 'utils/components/TimeSeriesChart/scale.ts';

/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */

const leftX = 5;

export const useYScale = useScale;

export const percentageFormat = (t: number) => t.toString() + '%';
export const toBpsFormat = (numberFormat: NumberFormat) => (t: number) =>
    numberFormat.n0(t) + 'bps';
export const useBpsFormat = (numberFormat: NumberFormat) =>
    useCallback(toBpsFormat(numberFormat), [numberFormat]);

export function renderYAxis(
    chart: any,
    data: any[],
    yScale: any,
    yTicks: number,
    yTickFormat?: (d: number) => string
) {
    if (data.length > 0) {
        chart.yTicks(yTicks).yTickFormat(yTickFormat);
        if (yTickFormat) {
            formatYTicks(chart, yScale, yTickFormat);
        } else {
            formatYTicksAsDecimals(chart, yScale);
        }
    } else {
        chart.yTicks(0);
    }
}

function formatYTicks(
    chart: any,
    yScale: any,
    yTickFormat: (d: number) => string
) {
    chart.yDecorate((selection: any) => {
        const node: any = selection.node();
        if (!node) {
            return;
        }

        const { height } = node.parentNode.getBoundingClientRect();

        selection.select('path').remove();
        selection
            .select('text')
            .classed('before-decimal', true)
            .attr('transform', `translate(${leftX}, 0)`)
            .style('visibility', (d: number) => {
                const yPosition = yScale(d);
                // hide y values which would appear truncated
                return yPosition >= 12 && yPosition <= height - 12
                    ? 'visible'
                    : 'hidden';
            })
            .classed(
                'bps-zero-tick',
                (d: number) => yTickFormat(0).endsWith('bps') && d === 0
            );
    });
}

function formatYTicksAsDecimals(chart: any, yScale: any) {
    chart.yDecorate((selection: any) => {
        const node: any = selection.node();
        if (!node) {
            return;
        }

        const { height } = node.parentNode.getBoundingClientRect();

        selection.select('path').remove();
        selection.select('text').text('');

        selection.select('text').attr('transform', `translate(${leftX}, 0)`);

        selection.select('text').style('visibility', (d: number) => {
            const yPosition = yScale(d);
            // hide y values which would appear truncated
            return yPosition >= 12 && yPosition <= height - 12
                ? 'visible'
                : 'hidden';
        });

        selection
            .select('text')
            .append('tspan')
            .text((d: number) => {
                const s = d ? d.toString() : '';
                const indexOfDecimalPoint = s.indexOf('.');
                return indexOfDecimalPoint === -1
                    ? s
                    : s.slice(0, s.indexOf('.'));
            })
            .classed('before-decimal', true);

        selection
            .select('text')
            .append('tspan')
            .text((d: number) => {
                const numbersAfterDecimal = (d.toString().split('.')[1] || [])
                    .length;
                const s = d ? d.toFixed(Math.max(2, numbersAfterDecimal)) : '';
                return s.slice(s.indexOf('.'));
            })
            .classed('after-decimal', true);
    });
}
